import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home.component';
import { ProfileComponent } from './profile/profile.component';
import { DealComponent } from './deal/deal.component';
import { DetailComponent } from './detail/detail.component';
import { SearchDetailComponent } from './search-detail/search-detail.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { SuccessComponent } from './success/success.component';
import { UnsuccessComponent } from './unsuccess/unsuccess.component';
// import { OffersComponent } from './offers/offers.component';
import { OfferViewComponent } from './offer-view/offer-view.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { ContactusComponent } from './contactus/contactus.component';
import { HomeSectorComponent } from './home-sector/home-sector.component';
import { TourDetailComponent } from './tour-detail/tour-detail.component';


const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: '', component: HomeComponent },
  { path: 'profile', component:ProfileComponent },
  { path: 'deal', component:DealComponent },
  { path: 'detail', component:DetailComponent },
  { path: 'search-detail', component:SearchDetailComponent},
  { path: 'terms-condition', component:TermsConditionComponent},
  { path: 'privacy-policy', component:PrivacyPolicyComponent},
  { path: 'home/success', component:SuccessComponent},
  { path: 'home/unsuccess', component:UnsuccessComponent},
  // { path: 'offers', component:OffersComponent},
  { path: 'offer-view', component:OfferViewComponent},
  { path: 'aboutus', component:AboutusComponent},
  { path: 'contactus', component:ContactusComponent},
  // { path: 'home-sector', component:HomeSectorComponent},
  { path: 'kfd', component:HomeSectorComponent},
  { path: 'tour-detail', component:TourDetailComponent},

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule {
 
 }
